/**
 * Border tokens
 * Defines border radius, widths, and styles
 */

export const borders = {
  // Border radius
  radius: {
    none: '0',
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    '2xl': '20px',
    '3xl': '24px',
    full: '9999px',
  },

  // Border widths
  width: {
    none: '0',
    thin: '1px',
    base: '2px',
    thick: '3px',
  },

  // Border styles
  style: {
    solid: 'solid',
    dashed: 'dashed',
    dotted: 'dotted',
  },
} as const;

export type Borders = typeof borders;
